var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteractive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 125,
    viewBox: "0 0 160 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0214844 3C0.0214844 1.34315 1.35629 0 3.00285 0H156.046C157.693 0 159.027 1.34315 159.027 3V23.163H0.0214844V3ZM0.0214844 24.163H159.027V121.082C159.027 122.738 157.693 124.082 156.046 124.082H3.00285C1.35629 124.082 0.0214844 122.738 0.0214844 121.082V24.163ZM26.9452 15.7258C29.1405 15.7258 30.9203 13.9228 30.9203 11.6986C30.9203 9.47444 29.1405 7.67139 26.9452 7.67139C24.7497 7.67139 22.97 9.47444 22.97 11.6986C22.97 13.9228 24.7497 15.7258 26.9452 15.7258ZM11.0498 15.7265C13.2452 15.7265 15.025 13.9235 15.025 11.6993C15.025 9.47517 13.2452 7.67212 11.0498 7.67212C8.85437 7.67212 7.07463 9.47517 7.07463 11.6993C7.07463 13.9235 8.85437 15.7265 11.0498 15.7265ZM46.8223 11.6986C46.8223 13.9228 45.0427 15.7258 42.8472 15.7258C40.6518 15.7258 38.872 13.9228 38.872 11.6986C38.872 9.47444 40.6518 7.67139 42.8472 7.67139C45.0427 7.67139 46.8223 9.47444 46.8223 11.6986Z",
    fill: "url(#paint0_linear_347_16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.06 80H42.8974C41.2508 80 39.916 81.3431 39.916 83V99.8571C39.916 101.514 41.2508 102.857 42.8974 102.857H118.06C119.707 102.857 121.042 101.514 121.042 99.8571V83C121.042 81.3431 119.707 80 118.06 80Z",
    fill: "url(#paint1_linear_347_16)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2918 48.9795H117.795V71.8366H38.2918V48.9795Z",
    fill: "url(#paint2_linear_347_16)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4043 96.3311H89.3327",
    stroke: "#FF4D4D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 96.3313H103.05",
    stroke: "#FF4D4D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.207 85.2886H103.05",
    stroke: "#FF4D4D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.307 65.0437H68.3782",
    stroke: "#AFAFAF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7266 65.0437H54.6608",
    stroke: "#AFAFAF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5039 54.001L54.661 54.001",
    stroke: "#AFAFAF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9162 71.8367C46.1888 71.8367 51.2738 66.7199 51.2738 60.4081C51.2738 54.0963 46.1888 48.9795 39.9162 48.9795C33.6436 48.9795 28.5586 54.0963 28.5586 60.4081C28.5586 66.7199 33.6436 71.8367 39.9162 71.8367Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.795 102.857C124.068 102.857 129.153 97.7404 129.153 91.4286C129.153 85.1168 124.068 80 117.795 80C111.522 80 106.438 85.1168 106.438 91.4286C106.438 97.7404 111.522 102.857 117.795 102.857Z",
    fill: "#FF4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_347_16",
    x1: 0.018311,
    y1: 112,
    x2: 76.2276,
    y2: -9.30209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717186",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_347_16",
    x1: 56.6184,
    y1: 91.4286,
    x2: 71.7918,
    y2: 67.3549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D4D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_347_16",
    x1: 45.0677,
    y1: 53.2652,
    x2: 51.9546,
    y2: 73.2996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9898AE",
    stopOpacity: 0.943428
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232330",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 125,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractive);
export default __webpack_public_path__ + "static/media/Interactive.316e13321887f68a4e45f16d07ed0057.svg";
export { ForwardRef as ReactComponent };